import React from "react";
import "./index.scss";
import ERROR_IMG from "../../resources/images/error.png";
const ErrorFallback = ({ error, resetErrorBoundary }) => {
  return (
    <div className="error-screen-con">
      <img src={ERROR_IMG} alt="Opps! something went wrong" />
      <h1>Oh no, something went wrong</h1>
      <p style={{ color: "red" }}>{error.message}</p>
    </div>
  );
};

export default ErrorFallback;
